module.exports = __webpack_public_path__ + "static/media/logo6.d1eeaf8a.png";